import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    insurer: "",
    memberID: "",
    policyOwner: {
        relationship: "Self",
        fname: "",
        lname: "",
        gender: "",
        dob: null,
    },
    cardFront: [],
    cardBack: [],
};

const insuranceSlice = createSlice({
    name: 'insurance',
    initialState,
    reducers: {
        reset: (state) => {
            return { ...initialState };
        },
        setInsurer: (state, action) => {
            state.insurer = action.payload;
        },
        setMemberID: (state, action) => {
            state.memberID = action.payload;
        },
        setPolicyOwner: (state, action) => {
            state.policyOwner = action.payload;
        },
        setCardFront: (state, action) => {
            state.cardFront = action.payload;
        },
        setCardBack: (state, action) => {
            state.cardBack = action.payload;
        },
        setInsurance: (state, action) => {
            return { ...state, ...action.payload };
        },
        setAllPatientInsuranceData: (state, action) => {
            return { ...state, ...action.payload };
        },
        setInsuranceFromAbandonedCart: (state, action) => {
            const ins = action.payload?.patient?.insurance || {};
            state.insurer = ins.payerName || state.insurer;

            const memberId = ins.memberId ?? ins.memberID;
            state.memberID = memberId || state.memberID;

            state.policyOwner = {
                relationship: ins.relationship || 'Self',
                fname: ins.relationshipDetails?.fname || '',
                lname: ins.relationshipDetails?.lname || '',
                gender: ins.relationshipDetails?.gender || '',
                dob: ins.relationshipDetails?.dateOfBirth || null,
            };

            state.cardFront = ins.cardFront ? [ins.cardFront] : [];
            state.cardBack = ins.cardBack ? [ins.cardBack] : [];
        },
    },
});

export const {
    reset,
    setInsurance,
    setInsurer,
    setMemberID,
    setPolicyOwner,
    setCardFront,
    setCardBack,
    setAllPatientInsuranceData,
    setInsuranceFromAbandonedCart
} = insuranceSlice.actions;

export default insuranceSlice.reducer;